export const getReportFile = `
   query getReportFile($id:ID!) {
       getReportFile(id:$id) {
         id
         created
         filename
         purpose
         size
         type
         url
       }
}`;
